import { toCents } from './money';

/**
 * Um valor monetário lido do banco é **confiável** quando é finito, não negativo e cabe nos centavos
 * exatos que o `money.ts` consegue representar.
 *
 * 🔴 Existe porque `toCents` degrada `NaN`/`Infinity`/`null` para `0` **em silêncio** — por design, para
 * que lixo não contamine uma soma inteira. A degradação é a resposta certa dentro do helper e a errada
 * na fronteira: somar `0` no lugar de um valor ilegível **esconde dinheiro**, e ninguém fica sabendo.
 * Quem lê um valor do banco decide o que fazer com o ilegível; quem soma, não.
 *
 * `Number.isSafeInteger(toCents(value))` cobre o valor grande demais: acima de ~9e13 reais a conversão
 * para centavos sai da faixa exata do double e a soma passa a errar silenciosamente.
 *
 * Morava em `libs/backend/order/utils` com dois consumidores (o cancelamento, que recusa ajustar a
 * conta, e o extrato do hóspede, que recusa exibir total que não fecha). Subiu para cá na F13, quando o
 * painel de contas virou o TERCEIRO leitor de dinheiro do banco — pelo argumento do próprio JSDoc
 * original: cópias divergiriam na primeira vez que alguém apertasse uma delas, e todas falam sobre o
 * mesmo dinheiro do mesmo hóspede. Vive ao lado do `money.ts` porque é a contraparte de leitura dele.
 */
export function isTrustworthyAmount(value: number | null | undefined): boolean {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 && Number.isSafeInteger(toCents(value));
}
